import api from './api';

function toCamel(str) {
  return str.replace(/_([a-z])/g, (_, c) => c.toUpperCase());
}

function mapKeys(obj) {
  if (Array.isArray(obj)) return obj.map(mapKeys);
  if (obj && typeof obj === 'object') {
    return Object.fromEntries(
      Object.entries(obj).map(([k, v]) => [toCamel(k), mapKeys(v)])
    );
  }
  return obj;
}

const ApplicationService = {
  async create(applicationData) {
    const { data } = await api.post('/applications', applicationData);
    return mapKeys(data.data);
  },

  async list(params = {}) {
    const { data } = await api.get('/applications', { params });
    return { data: (data.data || []).map(mapKeys), meta: data.meta };
  },

  async getOne(id) {
    const { data } = await api.get(`/applications/${id}`);
    return mapKeys(data.data);
  },

  async pay(id) {
    const { data } = await api.patch(`/applications/${id}/pay`);
    return mapKeys(data.data);
  },

  async cancel(id) {
    const { data } = await api.post(`/applications/${id}/cancel`);
    return mapKeys(data.data);
  },
};

export default ApplicationService;
